/**
 * Routes communes partagées par TOUTES les compagnies.
 * Ce sont les routes enfants du layout principal (views/dashboard/Index).
 */
export const commonRoutes = [
  // Dashboard (Contrat)
  {
    name: 'Dashboard',
    path: 'my_portal',
    meta: {
      translate: 'sidebar.my_portal',
      roles: ['user'],
      requiresAuth: true,
    },
    component: () => import('@/views/dashboard/Dashboard'),
  },
  // Dashboard (Responsable)
  {
    name: 'DashboardResponsable',
    path: 'my_portal_responsable',
    meta: {
      translate: 'sidebar.my_portal',
      roles: ['user'],
      requiresAuth: true,
    },
    component: () => import('@/views/dashboard/Dashboard'),
  },
  // Rapport
  {
    name: 'rapport',
    path: 'rapport',
    meta: {
      translate: 'sidebar.report',
      roles: ['user'],
      requiresAuth: true,
    },
    component: () => import('@/views/rapport/Rapport'),
  },
  // Chart
  {
    name: 'DashboardChart',
    path: 'dashboard',
    meta: {
      translate: 'sidebar.dashboard',
      roles: ['admin', 'niveau0'],
      requiresAuth: true,
    },
    component: () => import('@/views/chart/Chart'),
  },
  // Opération
  {
    name: 'operation-client',
    path: 'operation/client',
    meta: {
      translate: 'sidebar.operation',
      roles: ['admin', 'niveau0'],
      requiresAuth: true,
    },
    component: () => import('@/views/operation/OperationClient'),
  },
  {
    name: 'operation-contrat',
    path: 'operation/contrat',
    meta: {
      translate: 'sidebar.operation',
      roles: ['admin', 'niveau0'],
      requiresAuth: true,
    },
    component: () => import('@/views/operation/OperationContrat'),
  },
  {
    name: 'operation-commande',
    path: 'operation/commande',
    meta: {
      translate: 'sidebar.operation',
      roles: ['admin', 'niveau0'],
      requiresAuth: true,
    },
    component: () => import('@/views/operation/OperationCommande'),
  },
  {
    name: 'operation-facture',
    path: 'operation/facture',
    meta: {
      translate: 'sidebar.operation',
      roles: ['admin', 'niveau0'],
      requiresAuth: true,
    },
    component: () => import('@/views/operation/OperationFacture'),
  },
  {
    name: 'operation-tools',
    path: 'operation/tools',
    meta: {
      translate: 'sidebar.operation',
      roles: ['admin', 'niveau0'],
      requiresAuth: true,
    },
    component: () => import('@/views/operation/OperationTools'),
  },
  // Autre
  {
    name: 'other-parameters',
    path: 'other/parameters',
    meta: {
      translate: 'sidebar.other',
      roles: ['admin'],
      requiresAuth: true,
    },
    component: () => import('@/views/operation/OperationParameters'),
  },
  {
    name: 'other-messages',
    path: 'other/messages',
    meta: {
      translate: 'sidebar.other',
      roles: ['admin'],
      requiresAuth: true,
    },
    component: () => import('@/views/operation/OperationMessages'),
  },
  {
    name: 'other-list',
    path: 'other/list',
    meta: {
      translate: 'sidebar.other',
      roles: ['admin'],
      requiresAuth: true,
    },
    component: () => import('@/views/operation/OperationList'),
  },
  {
    name: 'other-toggles',
    path: 'other/toggles',
    meta: {
      translate: 'sidebar.other',
      roles: ['admin'],
      requiresAuth: true,
    },
    component: () => import('@/views/operation/OperationToggles'),
  },
]
